<div [ngClass]="isCustomUiChange ? 'loader-container' : 'spinner-center'" *ngIf="searching">
  <mat-spinner [diameter]="80" color="primary"></mat-spinner>
</div>
<div [ngClass]="isCustomUiChange ? 'role-container' : ''" [hidden]="searching">
  <mat-card [ngClass]="isCustomUiChange ? 'role-card' : 'user-card'">
    <mat-card-header *ngIf="!isCustomUiChange" style="width: 100% !important;">
      <mat-card-title style="width: 50% !important;margin-top: 0.2vw !important;
          margin-bottom: 0.5vw;font-size: 16px;">
        <!--  <div> -->
        <span matBadge="{{ roles.length }}" matBadgeOverlap="false" style="width: 50% !important; ">Roles</span>
        <!--  </div> -->
      </mat-card-title>
      <div style="width: 100% !important;">
        <button mat-button (click)="addNewRole()" matTooltip="Add"
          style="background: transparent;float:right !important; height: 100% !important">
          <mat-icon matTooltip="Add Role" aria-hidden="false" color="primary" style="text-align: center;
              width: 98%;float:right;">
            add
          </mat-icon>
        </button>
      </div>
    </mat-card-header>

    <!-- new CSS chages apply for FEMD and DOM1 -->
    <mat-card-header *ngIf="isCustomUiChange" class="role-header">
      <mat-card-title class="role-title">
        <span matBadge="{{ roles.length }}" matBadgeOverlap="false">Roles</span>
      </mat-card-title>

      <!-- Search Bar -->
      <mat-form-field appearance="outline" class="role-search-field">
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="searchValue" (ngModelChange)="applyFilter()"
          placeholder="Search role..." autocomplete="off" />
        <button mat-icon-button matSuffix *ngIf="searchValue" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <button mat-icon-button class="add-office-btn" (click)="addNewRole()">
        <mat-icon matTooltip="Add Office" color="primary">add</mat-icon>
      </button>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content [ngClass]="isCustomUiChange ? 'role-table-section' : 'card-section'">
      <br *ngIf="!isCustomUiChange">
      <table mat-table [dataSource]="dataSource" matSort
        [ngClass]="isCustomUiChange ? 'role-table' : 'table-card-section'" class="mat-elevation-z8">
        <ng-container matColumnDef="RoleId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Role ID</th>
          <td mat-cell *matCellDef="let role" matTooltip="{{ role.RoleId }}"> {{ role.RoleId }} </td>
        </ng-container>

        <ng-container matColumnDef="RoleName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'table-header-row'">
            Name</th>
          <td mat-cell *matCellDef="let role" matTooltip="{{ role.RoleId }}"> {{role.RoleName}} </td>
        </ng-container>

        <ng-container matColumnDef="RoleActive">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'table-header-row1'">
            Active</th>
          <td mat-cell *matCellDef="let role">
            <mat-icon matTooltip="Check" *ngIf="role.RoleActive" color="primary">check_box</mat-icon>
            <mat-icon matTooltip="Cancel" *ngIf="!role.RoleActive"
              style="color: red !important">cancel</mat-icon>
          </td>
        </ng-container>


        <ng-container matColumnDef="CreatedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
          <td mat-cell *matCellDef="let role"> {{role.CreatedDate | date:'shortDate' }} </td>
        </ng-container>

        <ng-container matColumnDef="ModifiedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Modified By</th>
          <td mat-cell *matCellDef="let role" matTooltip="{{ role.ModifiedBy }}"> {{role.ModifiedBy}} </td>
        </ng-container>


        <ng-container matColumnDef="edit" stickyEnd>
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="isCustomUiChange ? '' : 'table-header-row2'">
          </th>
          <td mat-cell *matCellDef="let role">
            <button mat-button (click)="handleClick(role)" matTooltip="Create">
              <mat-icon color="primary" matTooltip="Edit">create</mat-icon>
            </button>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5,10,20]" showFirstLastButtons></mat-paginator>
    </mat-card-content>
    <!--   <mat-card-actions>
          <button mat-raised-button color="primary" routerLink="/search">DONE</button>
        </mat-card-actions> -->
  </mat-card>
</div>

<div [ngClass]="isCustomUiChange ? '' : 'bottm-space'"></div>